import { render, staticRenderFns } from "./ModalDiagramTournament.vue?vue&type=template&id=5f398f12&scoped=true"
import script from "./ModalDiagramTournament.vue?vue&type=script&lang=js"
export * from "./ModalDiagramTournament.vue?vue&type=script&lang=js"
import style0 from "./ModalDiagramTournament.vue?vue&type=style&index=0&id=5f398f12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f398f12",
  null
  
)

export default component.exports